// Return focus to the triggering element when the Rebuy SmartCart closes.
// Rebuy handles opening the cart for all entry points (header link and ATC button).
(function () {
  var returnTo = null;      // snapshotted when cart opens, never overwritten by cart interactions

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-cart-opener]');
    if (el) returnTo = el;
  }, true);

  document.addEventListener('rebuy:smartcart.hide', function () {
    var el = returnTo;
    returnTo = null;
    if (el) setTimeout(function () { el.focus(); }, 10);
  });
}());

// Listen for cart changes from Rebuy and update the cart count in the theme

document.addEventListener('rebuy:cart.change', function(e) {
    if (e?.detail?.cart?.cart?.item_count != null) {
        window.dispatchEvent(new CustomEvent('updatecartcount', { detail: { cartTotal: e.detail.cart.cart.item_count } }));
    }
});

// Dropdown menu button

function initMenuButton(buttonId, menuId) {
    let button = document.getElementById(buttonId);
    let menu = document.getElementById(menuId);
    if (!button || !menu) return;

    let items = Array.from(menu.querySelectorAll('[role="menuitem"]'));

    function open() {
        menu.style.display = 'block';
        button.setAttribute('aria-expanded', 'true');
    }

    function close(restoreFocus) {
        menu.style.display = '';
        button.setAttribute('aria-expanded', 'false');
        if (restoreFocus) button.focus();
    }

    function isOpen() {
        return button.getAttribute('aria-expanded') === 'true';
    }

    function focusItem(i) {
        if (items[i]) items[i].focus();
    }

    button.addEventListener('click', function () {
        if (isOpen()) {
            close(true);
        } else {
            open();
            focusItem(0);
        }
    });

    button.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(); focusItem(0); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); open(); focusItem(items.length - 1); }
        else if (e.key === 'Escape') { close(true); }
    });

    menu.addEventListener('keydown', function (e) {
        let index = items.indexOf(document.activeElement);
        if (index === -1) return;

        if (e.key === 'ArrowDown') { e.preventDefault(); focusItem((index + 1) % items.length); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); focusItem((index - 1 + items.length) % items.length); }
        else if (e.key === 'Home') { e.preventDefault(); focusItem(0); }
        else if (e.key === 'End') { e.preventDefault(); focusItem(items.length - 1); }
        else if (e.key === 'Escape') { e.preventDefault(); close(true); }
    });

    document.addEventListener('click', function (e) {
        if (isOpen() && !button.contains(e.target) && !menu.contains(e.target)) {
            close(false);
        }
    });
}

initMenuButton('flavor-selector-dropbtn', 'flavor-selector-dropdown-content');
initMenuButton('collection-dropbtn', 'collection-dropdown-content');

// Sealbus accessibility fixes

function fixSealbusAccessibility() {
    // Doubled and nested radio elements

    let options = document.querySelectorAll('input.sls-option');
    if (options.length > 0) {
        options.forEach(option => option.setAttribute('aria-hidden', 'true'));
    }

    // Broken delivery interval label

    let label = Array.from(document.querySelectorAll('label')).find(label => label.textContent.trim().startsWith('Deliver every'));
    let select = document.querySelector('select[name="subs_interval"]');
    if (label && select) {
        label.setAttribute('for', 'SealDeliveryInterval');
        select.setAttribute('id', 'SealDeliveryInterval');
    }

    // Unnecessary label

    document.querySelector('label.sls-selling-plan-group-first-option')?.remove();

    // Move radio buttons inline with labels
    document.querySelectorAll('.sls-option-container').forEach(function (container) {
        if (container.dataset.radioMoved) return;
        var radioCol = container.querySelector('.seal-col-radio');
        var labelFirstLine = container.querySelector('.sls-label-container .sls-selling-plan-group-first-line');
        if (!radioCol || !labelFirstLine) return;

        var radioWrapper = radioCol.querySelector('.sls-selling-plan-group-first-line');
        if (radioWrapper) {
            labelFirstLine.insertBefore(radioWrapper, labelFirstLine.firstChild);
            radioCol.style.display = 'none';
        }
        container.dataset.radioMoved = 'true';
    });
}

var subscribeDefaultSelected = false;
function selectSubscribeByDefault() {
    if (subscribeDefaultSelected) return;
    var subOption = document.querySelector('.sls-option-container[data-selling-plan-group]');
    if (!subOption) return;
    var radio = subOption.querySelector('.sls-selling-plan-group-first-line[role="radio"]');
    if (!radio) return;
    if (subOption.classList.contains('sls-active')) { subscribeDefaultSelected = true; return; }
    radio.click();
    subscribeDefaultSelected = true;
}

// Flipping the order of subscription and one-time purchase options

function flipPurchaseOptions() {
    var container = document.querySelector('.sls-purchase-options-container');
    
    if (!container) return;

    let subscriptionOption = container.querySelector(':scope > div:has(.sls-trust-perks)');
    let oneTimeOption = container.querySelector(':scope > div:has(:not(.sls-trust-perks))');

    if (subscriptionOption && oneTimeOption && subscriptionOption.previousSibling === oneTimeOption)
        container.insertBefore(subscriptionOption, oneTimeOption);
}

function injectSubscriptionTrustPerks() {
    var target = document.querySelector('.sls-selling-plan-group-options');
    if (!target || target.querySelector('.sls-trust-perks')) return;

    var perks = document.createElement('ul');
    perks.className = 'sls-trust-perks';
    perks.setAttribute('aria-label', 'Subscription benefits');
    perks.innerHTML =
        '<li class="sls-trust-perk">' +
            '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
            '<span>Never run out of feel-good sweets</span>' +
        '</li>' +
        '<li class="sls-trust-perk">' +
            '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8V6a4 4 0 0 0-4-4H6a2 2 0 0 0-2 2v4"/><path d="M12 8V6a4 4 0 0 1 4-4h2a2 2 0 0 1 2 2v4"/><line x1="12" y1="12" x2="12" y2="16"/></svg>' +
            '<span>Free gift on your 2nd and 3rd shipment</span>' +
        '</li>' +
        '<li class="sls-trust-perk">' +
            '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="10" y1="9" x2="10" y2="15"/><line x1="14" y1="9" x2="14" y2="15"/></svg>' +
            '<span>Swap, pause, or cancel anytime</span>' +
        '</li>';

    target.insertBefore(perks, target.firstChild);
}

// run the function once on page load
fixSealbusAccessibility();
injectSubscriptionTrustPerks();
selectSubscribeByDefault();
flipPurchaseOptions();

// Observe for Seal Subscriptions widget changes.
// .sealsubs-target-element exists in Liquid on subscription form pages.
// On regular product pages Seal injects it dynamically, so fall back to #product-form.
var sealsubsTarget = document.querySelector('.sealsubs-target-element') || document.querySelector('#product-form');
if (sealsubsTarget) {
    var observer = new MutationObserver(function () {
        fixSealbusAccessibility();
        injectSubscriptionTrustPerks();
        selectSubscribeByDefault();
        flipPurchaseOptions();
    });
    observer.observe(sealsubsTarget, { childList: true, subtree: true });
}

function waitForElement(selector, callback) {
    const element = document.querySelector(selector);

    if (element) {
        callback(element);
    } else {
        setTimeout(() => waitForElement(selector, callback), 100);
    }
}

// Fix recommendation product buttons text

function FixRecommendationProductsButtonsText() {
    let SuggestedProductsButtons = [...document.querySelectorAll('h4')].find(h => h.textContent.trim() === 'You may also like')?.nextElementSibling?.querySelectorAll('div.rebuy-product-actions > button');

    if (SuggestedProductsButtons) {
        SuggestedProductsButtons.forEach(button => {
            let span = button.querySelector(':scope > span');
            if (span && span.textContent.trim() != 'Add')
            span.textContent = 'Add';
        });
    }
}

// Fix subscription buttons aria-label to include the discount information for screen readers

function FixSubscriptionButtonAriaLabel() {
    let subscriptionButtons = document.querySelectorAll('.rebuy-cart__flyout-item-subscription button');

    subscriptionButtons.forEach(button => {
        let text = button.textContent.trim();
        let match = text.match(/& Save \d+%/);
        if (match) {
            let saveText = match[0];
            let currentAriaLabel = button.getAttribute('aria-label') || '';
            if (!currentAriaLabel.includes(saveText)) {
                button.setAttribute('aria-label', currentAriaLabel + ' ' + saveText);
            }
        }
    });
}

// Prevents double announced progress bar status

function PreventDoubleAnnouncedProgressBarStatus() {
    document.querySelector('#rebuy-cart__progress-bar-meter-label')?.setAttribute('aria-hidden', 'true');
}

// Adjust focus after its lost due to removed elements from the DOM.

function PreventFocusLossOnCartUpdate(cart, liveRegion) {
    let lost = !document.activeElement || document.activeElement === document.body;
    let next = cart.querySelector("#rebuy-cart-title");

    next.setAttribute('tabindex', '-1');

    if (cartIsOpen && lost)
    {
        if (prevFocus.isConnected)
            next = prevFocus;
    
        if (liveRegion.textContent && liveRegion.textContent != previousStatusText)
        {
            let customLiveArea = document.querySelector('#custom-rebuy-live');
            if (!customLiveArea)
            {
                customLiveArea = document.createElement('div');
                customLiveArea.setAttribute('id', 'custom-rebuy-live');
                customLiveArea.setAttribute('aria-live', 'polite');
                customLiveArea.setAttribute('aria-atomic', 'true');
                customLiveArea.setAttribute('tabindex', '-1');
                customLiveArea.classList.add('sr-only');
                document.querySelector('[data-rebuy-cart-anchor=body]').insertAdjacentElement('beforebegin', customLiveArea);
            }
            customLiveArea.textContent = liveRegion.textContent;
            customLiveArea.focus({ preventScroll: true });
            previousStatusText = liveRegion.textContent;
            setTimeout(() => {
                next.focus({ preventScroll: true });
            }, 5000);
        }
        else if (Date.now() - lastFocusOnStatus > 1000)
            next.focus({ preventScroll: true });
        else
            return ;

        lastFocusOnStatus = Date.now();
    }
}

// Set aria-level="3" on flyout cart item product titles for correct heading hierarchy

function FixFlyoutItemTitleAriaLevel() {
    document.querySelectorAll('.rebuy-cart__flyout-item-product-title').forEach(function (title) {
        title.setAttribute('aria-level', '3');
    });
}

function rebuySmartCartFixes(cart) {
    FixRecommendationProductsButtonsText();
    FixSubscriptionButtonAriaLabel();
    PreventDoubleAnnouncedProgressBarStatus();
    FixFlyoutItemTitleAriaLevel();
    PreventFocusLossOnCartUpdate(cart, document.querySelector("#rebuy-cart-live-region"));
}

let cartIsOpen = false;
let prevFocus = null;
let previousStatusText = null;
let lastFocusOnStatus = 0;

waitForElement('#rebuy-cart', (cart) => {
    const observer = new MutationObserver((mutations) => {
        rebuySmartCartFixes(cart);
    });

    observer.observe(cart, { childList: true, subtree: true });
    rebuySmartCartFixes(cart);
    // One time sets
    cart.setAttribute('inert', '');
    document.addEventListener('rebuy:smartcart.show', () => {
        cartIsOpen = true;
        cart.removeAttribute('inert');
        document.querySelector("main").setAttribute('inert', '');
    });
    document.addEventListener('rebuy:smartcart.hide', () => {
        cartIsOpen = false;
        cart.setAttribute('inert', '');
        document.querySelector("main").removeAttribute('inert');
    });

    // Keep prevFocus up to date between mutations
    cart.addEventListener('focusin', (e) => {
        if (/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/i.test(e.target.tagName)) {
            prevFocus = e.target;
        }
    });
});